// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./SaveAsModal.module.scss";

import Modal from "components/Modal/Modal";
import FormElement from "components/FormElement/FormElement";
import Button from "components/Button/Button";

import {
    loadDocumentAction,
    saveAsDocumentAction
} from "store/actions/Actions";

const SaveAsModal = props => {

    const [state, setState] = useState({
        // number: props.tasks.length,
        file_name: "",
    });

    const [stateErrors, setStateErrors] = useState({
        task: "",
        due: "",
        assignee: "",
        selected_site: {},
    });

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const saveAsDocument = () => {
        if (!state.file_name) {
            setStateErrors({
                ...stateErrors,
                file_name: !state.file_name ? "File name required" : "",
            })
            return
        }

        let doc = {
            id : props.document.id
        };
        doc.folder_name = state.file_name;
        props.saveAsDocumentAction(doc);
        props.setShowModal(false);
    }

    return (
        <Modal
            className={styles.modal}
            setShowModal={props.setShowModal}
            
        >
            <div>
                <p className={styles["modal-heading"]}>Save as new file</p>

                <div className={styles["modal-content"]}>


                    <FormElement
                        labelText="File Name"
                        htmlFor="file_name"
                        errorMessage={stateErrors.task}
                    >
                        <input
                            type="text"
                            value={state["file_name"]}
                            placeholder="Enter file name"
                            onChange={handleChange("file_name")}
                        />
                    </FormElement>
    
                </div>

                <div className={styles["modal-footer"]}>
                    <Button
                        text="CANCEL"
                        color="secondary"
                        onClick={() => props.setShowModal(false)}
                    />
                    <Button
                        text="Save"
                        className={styles.create}
                        onClick={() => saveAsDocument()}
                    />
                </div>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    UsersReducer: state.UsersReducer,
    SitesReducer: state.SitesReducer
});

const mapDispatchToProps = {
    loadDocumentAction,
    saveAsDocumentAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveAsModal);
